import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="rich-text-editor"
export default class extends Controller {
  connect() {
    addEventListener('trix-initialize', () => {
      const toolbar = document.querySelector('trix-toolbar');
      this.removeUnwantedButtons();
      this.preventFileUpload();
    });
  }

  removeUnwantedButtons() {
    const buttonSelectors = [
      // '.trix-button--icon-italic',
      // '.trix-button--icon-strike',
      // '.trix-button--icon-quote',
      // '.trix-button--icon-number-list',
      // '.trix-button--icon-increase-nesting-level',
      // '.trix-button--icon-decrease-nesting-level',
      // '.trix-button--icon-bullet-list',
      // '.trix-button--icon-code',
      // '.trix-button-group--history-tools',
      '.trix-button-group--file-tools' /* to show file upload tools, comment this line and use with allowFileUpload */
    ];

    buttonSelectors.forEach(selector => {
      const button = document.querySelector(selector);
      if (button) button.remove();
    });
  }

  // allowFileUpload() {    
  //   addEventListener('trix-file-accept', function(e) {
  //     const acceptedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif']
  //     if (!acceptedTypes.includes(e.file.type)) {
  //       e.preventDefault()
  //       alert("Only images files are allowed.")
  //     }
  //   })
  // }

  preventFileUpload() {
    addEventListener('trix-file-accept', (e) => e.preventDefault());
  }
}
